module.exports = __webpack_public_path__ + "static/media/wedo3.2a5dccd5.svg";